import React, { Component } from "react";
import { postRequest, withRequest } from "../../../utils/request";
import { auth } from "../../../utils/auth";
import { apiUrl } from "../../../utils/apiUrl";
import Loader from "../../general/Loader";
import { formatCurrency, formatNumber, getLink } from "../../../utils/helpers";
import { Link } from "react-router-dom";
import Pagination from "../../general/Pagination";
import { debounce } from "lodash";

const queryDeFiltros = (filtros) =>
    Object.keys(filtros)
        .map((fil) => `${fil}=${filtros[fil]}`)
        .join("&");

class Compras extends Component {
    state = {
        compras: [],
        showCreate: false,
        loading: true,
        meta: [],
        links: [],
        filtrosQuery: "",
    };
    componentDidMount() {
        this.setState({
            filtrosQuery: `?item=${this.props.item.id}`,
        });
        this.getCompras();
    }
    getCompras = async (url = null) => {
        const id = this.props.item.id;
        url = url ? url : `compras?item=${id}&limit=20`;
        const data = await this.props.request(url);

        console.log(data);

        if (data) {
            this.setState({
                compras: data.data,
                meta: data.meta,
                links: data.links,
                loading: false,
            });
        }

        this.setState({ loading: false });
    };
    removeAjuste = async (event, item) => {
        event.preventDefault();



        const url = `items/${item}`;

        const response = await postRequest(apiUrl(url), {}, 'delete');



        if (response.success) {
            this.getCompras();
            this.props.getItem();
            return;
        } else {
            this.setState({ errors: response.data.message });
        }

        this.setState({ loading: false });
    };
    toggleCreateModal = () => {
        this.setState({
            showCreate: !this.state.showCreate,
        });
    };
    // `await this.setState()` no espera al re-render: setState no devuelve una
    // promesa, así que la continuación se reanudaba antes de que React
    // aplicara el update y `this.state.filtros` tenía los filtros anteriores.
    // Por eso cada consulta salía un filtro atrás y el primer intento no
    // filtraba nada. El estado se actualiza con la forma funcional y la consulta
    // se lanza en el callback de setState, que sí corre después del commit.
    onFiltroChange = (value, filtro) => {
        this.setState((state) => {
            const filtros = { ...state.filtros, [filtro]: value };

            return { filtros, filtrosQuery: `?item=${this.props.item.id}&` + queryDeFiltros(filtros) };
        }, this.buscarConFiltros);
    };
    // El debounce va sobre la petición, no sobre el cambio de filtro: `debounce`
    // era uno solo para todos los campos, y cambiar dos filtros en menos de 500ms
    // descartaba el primero junto con su valor.
    buscarConFiltros = debounce(() => {
        const query = queryDeFiltros(this.state.filtros);

        this.getCompras(
            `compras?item=${this.props.item.id}&` + query
        );
    }, 500);
    render() {
        const { item } = this.props;
        const { loading, compras, meta, links, filtrosQuery } = this.state;

        if (loading === true) {
            return <Loader />;
        }
        return (
            <div>
                <h3>Historial de compras de {item.nombre}</h3>
                <div className='page-controls'>
                    <div className='table-data__tool'>
                        <div className='table-data__tool-left row'>
                            <div className='col-md-4'>
                                <label htmlFor='desde'>Desde</label>
                                <input
                                    type='date'
                                    name='desde'
                                    id='desde'
                                    className='form-control'
                                    onChange={(e) =>
                                        this.onFiltroChange(
                                            e.target.value,
                                            "desde"
                                        )
                                    }
                                />
                            </div>
                            <div className='col-md-4'>
                                <label htmlFor='hasta'>Hasta</label>
                                <input
                                    type='date'
                                    name='hasta'
                                    id='hasta'
                                    className='form-control'
                                    onChange={(e) =>
                                        this.onFiltroChange(
                                            e.target.value,
                                            "hasta"
                                        )
                                    }
                                />
                            </div>
                            <div className='col-md-4 text-right p-t-25'>
                                <Link
                                    to={getLink(
                                        `/imprimir/compras-item${filtrosQuery}`
                                    )}
                                    target='_blank'
                                    className='au-btn-filter m-r-15'>
                                    <i className='zmdi zmdi-print' /> Imprimir
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
                {compras && compras.length > 0 ? (
                    <table className='table tickets-table'>
                        <thead>
                            <tr>
                                <th>Fecha</th>
                                <th style={{ width: 250 }}>Suplidor</th>
                                <th className='text-right'>Cantidad</th>
                                <th className='text-right'>Costo/UND</th>
                                <th className='text-right'>Total</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            {compras.map((compra) => (
                                <tr key={compra.id}>
                                    <td>{compra.fecha}</td>
                                    <td>{compra.suplidor}</td>
                                    <td className='text-right'>
                                        {formatNumber(compra.cantidad)}
                                    </td>
                                    <td className='text-right'>
                                        {formatCurrency(compra.costo)}
                                    </td>
                                    <td className='text-right'>
                                        {formatCurrency(
                                            compra.costo * compra.cantidad
                                        )}
                                    </td>
                                    <td className='text-right'>
                                        <Link
                                            to={getLink(
                                                `/compras/${compra.compraId}`
                                            )}>
                                            Ver Compra
                                        </Link>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                ) : (
                    <div>No se han realidado compras de este item.</div>
                )}
                {meta && (
                    <Pagination
                        links={links}
                        meta={meta}
                        getData={this.getCompras}
                    />
                )}
            </div>
        );
    }
}

export default withRequest(Compras);
